import React from 'react';
import {FileText} from 'lucide-react';
import {useApiSearchStudentHomeworks} from "@/api/homework";
import RenderIf from "@/components/render-if";
import {formatDate} from "@/lib/helper/date";
import {Button, Empty, Spin} from "antd";
import {URLS} from "@/lib/urls";
import {Link} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";

function HomeworkSection({id, lessonDetail}) {

    const {data: homeworks, isPending, isSuccess} = useApiSearchStudentHomeworks({lesson_id: lessonDetail?.id});

    const getStatusColor = (reportCount) => {
        switch (reportCount) {
            case 0:
                return 'bg-orange-100 text-orange-800 border-orange-200';

            default:
                return 'bg-green-100 text-green-800 border-green-200';
        }
    };


    return (
        <>
            {/* Assignments Section */}
            <div className="rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-600">
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-2 bg-orange-100 rounded-lg">
                        <FileText className="w-6 h-6 text-orange-600"/>
                    </div>
                    <h2 className="text-2xl font-bold ">تکالیف</h2>
                </div>
                <RenderIf condition={isPending}>
                    <div className={'flex justify-center'}>

                        <Spin spinning={true}/>
                    </div>
                </RenderIf>

                <RenderIf condition={homeworks?.data?.data?.length === 0}>

                    <Empty
                        description={'هیچ تکلیفی برای انجام ندارید'}
                    />
                </RenderIf>

                <div className="space-y-4">
                    <RenderIf condition={homeworks?.data?.data?.length > 0}>
                        {homeworks?.data?.data?.map((homework) => (
                            <div key={homework.id}
                                 className="border dark:border-gray-600 rounded-xl p-5 hover:shadow-md transition-all duration-200">
                                <div className="flex items-start justify-between mb-4 flex-wrap">
                                    <div className="flex-1">
                                        <h3 className="font-semibold  mb-2">{homework.title}</h3>
                                        <p className={'line-clamp-3'}>{homework?.description}</p>
                                        <RenderIf condition={homework.date}>
                                            <p className="text-sm "> مهلت انجام
                                                : {formatDate(homework.date, 'YYY-MM-DD')}</p>
                                        </RenderIf>
                                    </div>
                                    <div className="flex flex-col items-end gap-2 justify-between">
                                        <span
                                            className={`px-3 py-1 rounded-full text-xs font-medium border ${getStatusColor(homework.reports_count ?? 0)}`}>
                                          {homework.reports_count > 0 ? 'ارسال شده' : 'در انتظار ارسال'}
                                        </span>

                                        <div>
                                            <Link to={sprintf(URLS.student.lessons.myLesson.homework, {
                                                id: id,
                                                homeworkId: homework.id
                                            })}>
                                                <Button className={'mt-2'} variant={'dashed'}>نمایش
                                                    جزئیات</Button>
                                            </Link>
                                        </div>

                                    </div>
                                </div>


                            </div>
                        ))}
                    </RenderIf>

                </div>
            </div>

        </>
    );
}

export default HomeworkSection;